import { Trans } from "react-i18next";
import styled from "styled-components";

const CircleNumber = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.duo.color.primary};
  color: ${({ theme }) => theme.duo.color.primary};
  text-align: center;
`;

const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 5px 0;
`;
const StepRow = styled.div`
  display: flex;
  align-items: center;
`;
const StepText = styled.div`
  margin-left: 12px;
  flex: 1;
  color: ${({ theme }) => theme.duo.color.text};
  text-align: left;
`;

export const VideoTutorialSteps = () => {
  return (
    <StepsWrapper>
      <StepRow>
        <CircleNumber>1</CircleNumber>
        <StepText>
          <Trans>
            <b>Hold your finger</b> for 2 seconds on a word
          </Trans>
        </StepText>
      </StepRow>
      <StepRow>
        <CircleNumber>2</CircleNumber>
        <StepText>
          <Trans>
            <b>Click on plus icon</b> to save it to your deck
          </Trans>
        </StepText>
      </StepRow>
    </StepsWrapper>
  );
};
